// import { configureStore } from '@reduxjs/toolkit';
// import type { EnhancedStore } from '@reduxjs/toolkit';
// import thunkMiddleware from 'redux-thunk';

// import rootReducer from './reducers';

// /* eslint-disable no-underscore-dangle */

// export const storeFactory: () => EnhancedStore = () =>
//   configureStore({
//     reducer: rootReducer,
//     middleware: (getDefaultMiddleware: any) => getDefaultMiddleware().concat(thunkMiddleware),
//     devTools: process.env.NODE_ENV !== 'production',
//   });

// export default storeFactory();


// import { createStore, applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import type { EnhancedStore } from '@reduxjs/toolkit';
import type { Store } from 'redux';
import thunkMiddleware from 'redux-thunk';

import rootReducer from './reducers';

// /* eslint-disable no-underscore-dangle */

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// // $FlowFixMe
// export const storeFactory: Store = () =>
//   createStore(rootReducer, composeEnhancers(applyMiddleware(thunkMiddleware)));

export const storeFactory: () => EnhancedStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware: any) => getDefaultMiddleware({
      serializableCheck: false
    }).concat(thunkMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });

export default storeFactory();